import { defineNuxtPlugin } from '#app/nuxt'
import { LazySvgoAirdropArrow, LazySvgoAirdropDone, LazySvgoAirdropIcFuturesAccount, LazySvgoAirdropIcGonggao, LazySvgoAirdropIcHelp, LazySvgoAirdropIcLanguage, LazySvgoAirdropIcNotebook, LazySvgoAirdropIcTelegram, LazySvgoAirdropIcX, LazySvgoApiManagementAdd, LazySvgoApiManagementWarning, LazySvgoAssetsIcAlert, LazySvgoAssetsIcCheck, LazySvgoAssetsIcEdit, LazySvgoAssetsIcNotebook, LazySvgoAssetsStatusSuccess, LazySvgoAssetsWithdrawIcFail, LazySvgoAssetsWithdrawIcSuccess, LazySvgoCommonAppLightLogo, LazySvgoCommonAppLogo, LazySvgoCommonArrowDown, LazySvgoCommonArrowRight, LazySvgoCommonArrowUp, LazySvgoCommonArrow, LazySvgoCommonBtnLoading, LazySvgoCommonCheck, LazySvgoCommonCodeQr, LazySvgoCommonCopy, LazySvgoCommonCopy2, LazySvgoCommonDelete, LazySvgoCommonDownload, LazySvgoCommonError, LazySvgoCommonEyeClose, LazySvgoCommonEye, LazySvgoCommonFire, LazySvgoCommonIconChevronDown, LazySvgoCommonIconClear, LazySvgoCommonIconFavTrade, LazySvgoCommonIconLogoQrWhite, LazySvgoCommonIconNotice, LazySvgoCommonIconSearch, LazySvgoCommonIconTip, LazySvgoCommonIconLogoQr, LazySvgoCommonLoading, LazySvgoCommonModalHint, LazySvgoCommonNoDataSearch, LazySvgoCommonNoData, LazySvgoCommonPagiationArrow, LazySvgoCommonSearchClear, LazySvgoCommonSelectArrow, LazySvgoCommonSolidTriangle, LazySvgoCommonSuccess, LazySvgoCommonUsdt, LazySvgoCommonWaring2, LazySvgoCommonWarning, LazySvgoCommonWarning3, LazySvgoFooterArrow, LazySvgoFooterFacebook, LazySvgoFooterLinkedin, LazySvgoFooterMedium, LazySvgoFooterTelegram, LazySvgoFooterTiktok, LazySvgoFooterX, LazySvgoFooterYoutube, LazySvgoFuturesBonus, LazySvgoFuturesBonusPosition, LazySvgoFuturesHelp, LazySvgoFuturesIconTelegram, LazySvgoFuturesIconTpslEdit, LazySvgoFuturesIconX, LazySvgoFuturesKlineArea, LazySvgoFuturesKlineBars, LazySvgoFuturesKlineBaseline, LazySvgoFuturesKlineCandle, LazySvgoFuturesKlineHeikinAshi, LazySvgoFuturesKlineHilo, LazySvgoFuturesKlineHollowCandle, LazySvgoFuturesKlineKagi, LazySvgoFuturesKlineLineBreak, LazySvgoFuturesKlineLine, LazySvgoFuturesKlinePointFigure, LazySvgoFuturesKlineRenko, LazySvgoFuturesMinusSign, LazySvgoFuturesPlusSign, LazySvgoFuturesResetLayout, LazySvgoFuturesRiskWidgetBg, LazySvgoFuturesRiskWidgetPointer, LazySvgoFuturesSetting, LazySvgoFuturesTransferArrow, LazySvgoFuturesTransferFuture, LazySvgoFuturesTransferSpot, LazySvgoFuturesTransferTrialfund, LazySvgoFuturesTransfer, LazySvgoHeaderIconAccount, LazySvgoHeaderIconApi, LazySvgoHeaderIconArrowRight, LazySvgoHeaderIconCard, LazySvgoHeaderIconChecked, LazySvgoHeaderIconClose, LazySvgoHeaderIconDeposit, LazySvgoHeaderIconFee, LazySvgoHeaderIconFund, LazySvgoHeaderIconFuturesAsset, LazySvgoHeaderIconFutures, LazySvgoHeaderIconInvite, LazySvgoHeaderIconLogout, LazySvgoHeaderIconNewAPI, LazySvgoHeaderIconOrder, LazySvgoHeaderIconPerpetual, LazySvgoHeaderIconSpotAsset, LazySvgoHeaderIconSpot, LazySvgoHeaderIconTotalAsset, LazySvgoHeaderIconTransfer, LazySvgoHeaderIconUser, LazySvgoHeaderIconWallet, LazySvgoHeaderIconWithdraw, LazySvgoHomeArrow, LazySvgoHomeBanner, LazySvgoHomeBeginnerGuide, LazySvgoHomeFutures, LazySvgoHomeGuide1, LazySvgoHomeGuide2, LazySvgoHomeGuide3, LazySvgoHomeHot, LazySvgoHomeIcClose, LazySvgoHomeIcOpen, LazySvgoHomeIcRightArrow, LazySvgoHomeIcService, LazySvgoHomeIconMore, LazySvgoHomeLogo, LazySvgoHomeQrcode, LazySvgoHomeService, LazySvgoHomeServiceEarn, LazySvgoHomeServiceFutures, LazySvgoHomeServicePrime, LazySvgoHomeServiceSpot, LazySvgoHomeSpot, LazySvgoHomeSupport, LazySvgoHomeTop, LazySvgoJoinUsX, LazySvgoJoinUsGroup, LazySvgoJoinUsTg, LazySvgoKycAdd, LazySvgoKycCardBlackBg, LazySvgoKycCardWhiteBg, LazySvgoKycDone, LazySvgoKycIdCard, LazySvgoKycPhone, LazySvgoKycUpload, LazySvgoLinksHeader, LazySvgoMarketDarkSelected, LazySvgoMarketDarkUnselected, LazySvgoMarketFavorite, LazySvgoMarketFuture, LazySvgoMarketLightSelected, LazySvgoMarketLightUnselected, LazySvgoMarketNoStar, LazySvgoMarketSearch, LazySvgoMarketSpots, LazySvgoMarketStar, LazySvgoMyIconsAccounts, LazySvgoMyIconsDeposit, LazySvgoMyIconsOrders, LazySvgoMyIconsWithdraw, LazySvgoMyWalletRecord, LazySvgoReferralArrow, LazySvgoReferralIcHow1, LazySvgoReferralIcHow2, LazySvgoReferralIcHow3, LazySvgoReferralIcQrCode, LazySvgoReferralLogo, LazySvgoSignUpArrow, LazySvgoSignUpCheck, LazySvgoSignUpClose, LazySvgoSignUpCountryArrow, LazySvgoSignUpEyeClose, LazySvgoSignUpEyeOpen, LazySvgoSignUpPass, LazySvgoSpotBg, LazySvgoSpotIcAdd, LazySvgoSpotIcAttention, LazySvgoSpotIcCalculatorS, LazySvgoSpotIcFire, LazySvgoSpotIcHistory, LazySvgoSpotIcProfitSharing, LazySvgoSpotIcWebsite, LazySvgoSpotIcWhitePaper, LazySvgoSpotIcZoomout, LazySvgoSpotIconCamera, LazySvgoSpotIconFullscreen, LazySvgoSpotIconIcRight, LazySvgoSpotIconIndicators, LazySvgoSpotIconSetting, LazySvgoUserAdvancedcertification, LazySvgoUserAlert, LazySvgoUserApple, LazySvgoUserBasiccertification, LazySvgoUserCertificationstatus, LazySvgoUserCheck, LazySvgoUserCircle, LazySvgoUserClose, LazySvgoUserDel, LazySvgoUserDeposit, LazySvgoUserDown, LazySvgoUserEmail, LazySvgoUserFishing, LazySvgoUserGa, LazySvgoUserGooglePlay, LazySvgoUserHeadImg, LazySvgoUserIphone, LazySvgoUserKycCardFront, LazySvgoUserKycCardThird, LazySvgoUserKycInfo, LazySvgoUserKyc, LazySvgoUserLevel, LazySvgoUserMenu, LazySvgoUserPassword, LazySvgoUserSafety, LazySvgoUserSecretKey, LazySvgoUserSecurity, LazySvgoUserTransfer, LazySvgoUserUnverified, LazySvgoUserVerifyState, LazySvgoUserVerify, LazySvgoUserWithdraw } from '#components'
const lazyGlobalComponents = [
  ["SvgoAirdropArrow", LazySvgoAirdropArrow],
["SvgoAirdropDone", LazySvgoAirdropDone],
["SvgoAirdropIcFuturesAccount", LazySvgoAirdropIcFuturesAccount],
["SvgoAirdropIcGonggao", LazySvgoAirdropIcGonggao],
["SvgoAirdropIcHelp", LazySvgoAirdropIcHelp],
["SvgoAirdropIcLanguage", LazySvgoAirdropIcLanguage],
["SvgoAirdropIcNotebook", LazySvgoAirdropIcNotebook],
["SvgoAirdropIcTelegram", LazySvgoAirdropIcTelegram],
["SvgoAirdropIcX", LazySvgoAirdropIcX],
["SvgoApiManagementAdd", LazySvgoApiManagementAdd],
["SvgoApiManagementWarning", LazySvgoApiManagementWarning],
["SvgoAssetsIcAlert", LazySvgoAssetsIcAlert],
["SvgoAssetsIcCheck", LazySvgoAssetsIcCheck],
["SvgoAssetsIcEdit", LazySvgoAssetsIcEdit],
["SvgoAssetsIcNotebook", LazySvgoAssetsIcNotebook],
["SvgoAssetsStatusSuccess", LazySvgoAssetsStatusSuccess],
["SvgoAssetsWithdrawIcFail", LazySvgoAssetsWithdrawIcFail],
["SvgoAssetsWithdrawIcSuccess", LazySvgoAssetsWithdrawIcSuccess],
["SvgoCommonAppLightLogo", LazySvgoCommonAppLightLogo],
["SvgoCommonAppLogo", LazySvgoCommonAppLogo],
["SvgoCommonArrowDown", LazySvgoCommonArrowDown],
["SvgoCommonArrowRight", LazySvgoCommonArrowRight],
["SvgoCommonArrowUp", LazySvgoCommonArrowUp],
["SvgoCommonArrow", LazySvgoCommonArrow],
["SvgoCommonBtnLoading", LazySvgoCommonBtnLoading],
["SvgoCommonCheck", LazySvgoCommonCheck],
["SvgoCommonCodeQr", LazySvgoCommonCodeQr],
["SvgoCommonCopy", LazySvgoCommonCopy],
["SvgoCommonCopy2", LazySvgoCommonCopy2],
["SvgoCommonDelete", LazySvgoCommonDelete],
["SvgoCommonDownload", LazySvgoCommonDownload],
["SvgoCommonError", LazySvgoCommonError],
["SvgoCommonEyeClose", LazySvgoCommonEyeClose],
["SvgoCommonEye", LazySvgoCommonEye],
["SvgoCommonFire", LazySvgoCommonFire],
["SvgoCommonIconChevronDown", LazySvgoCommonIconChevronDown],
["SvgoCommonIconClear", LazySvgoCommonIconClear],
["SvgoCommonIconFavTrade", LazySvgoCommonIconFavTrade],
["SvgoCommonIconLogoQrWhite", LazySvgoCommonIconLogoQrWhite],
["SvgoCommonIconNotice", LazySvgoCommonIconNotice],
["SvgoCommonIconSearch", LazySvgoCommonIconSearch],
["SvgoCommonIconTip", LazySvgoCommonIconTip],
["SvgoCommonIconLogoQr", LazySvgoCommonIconLogoQr],
["SvgoCommonLoading", LazySvgoCommonLoading],
["SvgoCommonModalHint", LazySvgoCommonModalHint],
["SvgoCommonNoDataSearch", LazySvgoCommonNoDataSearch],
["SvgoCommonNoData", LazySvgoCommonNoData],
["SvgoCommonPagiationArrow", LazySvgoCommonPagiationArrow],
["SvgoCommonSearchClear", LazySvgoCommonSearchClear],
["SvgoCommonSelectArrow", LazySvgoCommonSelectArrow],
["SvgoCommonSolidTriangle", LazySvgoCommonSolidTriangle],
["SvgoCommonSuccess", LazySvgoCommonSuccess],
["SvgoCommonUsdt", LazySvgoCommonUsdt],
["SvgoCommonWaring2", LazySvgoCommonWaring2],
["SvgoCommonWarning", LazySvgoCommonWarning],
["SvgoCommonWarning3", LazySvgoCommonWarning3],
["SvgoFooterArrow", LazySvgoFooterArrow],
["SvgoFooterFacebook", LazySvgoFooterFacebook],
["SvgoFooterLinkedin", LazySvgoFooterLinkedin],
["SvgoFooterMedium", LazySvgoFooterMedium],
["SvgoFooterTelegram", LazySvgoFooterTelegram],
["SvgoFooterTiktok", LazySvgoFooterTiktok],
["SvgoFooterX", LazySvgoFooterX],
["SvgoFooterYoutube", LazySvgoFooterYoutube],
["SvgoFuturesBonus", LazySvgoFuturesBonus],
["SvgoFuturesBonusPosition", LazySvgoFuturesBonusPosition],
["SvgoFuturesHelp", LazySvgoFuturesHelp],
["SvgoFuturesIconTelegram", LazySvgoFuturesIconTelegram],
["SvgoFuturesIconTpslEdit", LazySvgoFuturesIconTpslEdit],
["SvgoFuturesIconX", LazySvgoFuturesIconX],
["SvgoFuturesKlineArea", LazySvgoFuturesKlineArea],
["SvgoFuturesKlineBars", LazySvgoFuturesKlineBars],
["SvgoFuturesKlineBaseline", LazySvgoFuturesKlineBaseline],
["SvgoFuturesKlineCandle", LazySvgoFuturesKlineCandle],
["SvgoFuturesKlineHeikinAshi", LazySvgoFuturesKlineHeikinAshi],
["SvgoFuturesKlineHilo", LazySvgoFuturesKlineHilo],
["SvgoFuturesKlineHollowCandle", LazySvgoFuturesKlineHollowCandle],
["SvgoFuturesKlineKagi", LazySvgoFuturesKlineKagi],
["SvgoFuturesKlineLineBreak", LazySvgoFuturesKlineLineBreak],
["SvgoFuturesKlineLine", LazySvgoFuturesKlineLine],
["SvgoFuturesKlinePointFigure", LazySvgoFuturesKlinePointFigure],
["SvgoFuturesKlineRenko", LazySvgoFuturesKlineRenko],
["SvgoFuturesMinusSign", LazySvgoFuturesMinusSign],
["SvgoFuturesPlusSign", LazySvgoFuturesPlusSign],
["SvgoFuturesResetLayout", LazySvgoFuturesResetLayout],
["SvgoFuturesRiskWidgetBg", LazySvgoFuturesRiskWidgetBg],
["SvgoFuturesRiskWidgetPointer", LazySvgoFuturesRiskWidgetPointer],
["SvgoFuturesSetting", LazySvgoFuturesSetting],
["SvgoFuturesTransferArrow", LazySvgoFuturesTransferArrow],
["SvgoFuturesTransferFuture", LazySvgoFuturesTransferFuture],
["SvgoFuturesTransferSpot", LazySvgoFuturesTransferSpot],
["SvgoFuturesTransferTrialfund", LazySvgoFuturesTransferTrialfund],
["SvgoFuturesTransfer", LazySvgoFuturesTransfer],
["SvgoHeaderIconAccount", LazySvgoHeaderIconAccount],
["SvgoHeaderIconApi", LazySvgoHeaderIconApi],
["SvgoHeaderIconArrowRight", LazySvgoHeaderIconArrowRight],
["SvgoHeaderIconCard", LazySvgoHeaderIconCard],
["SvgoHeaderIconChecked", LazySvgoHeaderIconChecked],
["SvgoHeaderIconClose", LazySvgoHeaderIconClose],
["SvgoHeaderIconDeposit", LazySvgoHeaderIconDeposit],
["SvgoHeaderIconFee", LazySvgoHeaderIconFee],
["SvgoHeaderIconFund", LazySvgoHeaderIconFund],
["SvgoHeaderIconFuturesAsset", LazySvgoHeaderIconFuturesAsset],
["SvgoHeaderIconFutures", LazySvgoHeaderIconFutures],
["SvgoHeaderIconInvite", LazySvgoHeaderIconInvite],
["SvgoHeaderIconLogout", LazySvgoHeaderIconLogout],
["SvgoHeaderIconNewAPI", LazySvgoHeaderIconNewAPI],
["SvgoHeaderIconOrder", LazySvgoHeaderIconOrder],
["SvgoHeaderIconPerpetual", LazySvgoHeaderIconPerpetual],
["SvgoHeaderIconSpotAsset", LazySvgoHeaderIconSpotAsset],
["SvgoHeaderIconSpot", LazySvgoHeaderIconSpot],
["SvgoHeaderIconTotalAsset", LazySvgoHeaderIconTotalAsset],
["SvgoHeaderIconTransfer", LazySvgoHeaderIconTransfer],
["SvgoHeaderIconUser", LazySvgoHeaderIconUser],
["SvgoHeaderIconWallet", LazySvgoHeaderIconWallet],
["SvgoHeaderIconWithdraw", LazySvgoHeaderIconWithdraw],
["SvgoHomeArrow", LazySvgoHomeArrow],
["SvgoHomeBanner", LazySvgoHomeBanner],
["SvgoHomeBeginnerGuide", LazySvgoHomeBeginnerGuide],
["SvgoHomeFutures", LazySvgoHomeFutures],
["SvgoHomeGuide1", LazySvgoHomeGuide1],
["SvgoHomeGuide2", LazySvgoHomeGuide2],
["SvgoHomeGuide3", LazySvgoHomeGuide3],
["SvgoHomeHot", LazySvgoHomeHot],
["SvgoHomeIcClose", LazySvgoHomeIcClose],
["SvgoHomeIcOpen", LazySvgoHomeIcOpen],
["SvgoHomeIcRightArrow", LazySvgoHomeIcRightArrow],
["SvgoHomeIcService", LazySvgoHomeIcService],
["SvgoHomeIconMore", LazySvgoHomeIconMore],
["SvgoHomeLogo", LazySvgoHomeLogo],
["SvgoHomeQrcode", LazySvgoHomeQrcode],
["SvgoHomeService", LazySvgoHomeService],
["SvgoHomeServiceEarn", LazySvgoHomeServiceEarn],
["SvgoHomeServiceFutures", LazySvgoHomeServiceFutures],
["SvgoHomeServicePrime", LazySvgoHomeServicePrime],
["SvgoHomeServiceSpot", LazySvgoHomeServiceSpot],
["SvgoHomeSpot", LazySvgoHomeSpot],
["SvgoHomeSupport", LazySvgoHomeSupport],
["SvgoHomeTop", LazySvgoHomeTop],
["SvgoJoinUsX", LazySvgoJoinUsX],
["SvgoJoinUsGroup", LazySvgoJoinUsGroup],
["SvgoJoinUsTg", LazySvgoJoinUsTg],
["SvgoKycAdd", LazySvgoKycAdd],
["SvgoKycCardBlackBg", LazySvgoKycCardBlackBg],
["SvgoKycCardWhiteBg", LazySvgoKycCardWhiteBg],
["SvgoKycDone", LazySvgoKycDone],
["SvgoKycIdCard", LazySvgoKycIdCard],
["SvgoKycPhone", LazySvgoKycPhone],
["SvgoKycUpload", LazySvgoKycUpload],
["SvgoLinksHeader", LazySvgoLinksHeader],
["SvgoMarketDarkSelected", LazySvgoMarketDarkSelected],
["SvgoMarketDarkUnselected", LazySvgoMarketDarkUnselected],
["SvgoMarketFavorite", LazySvgoMarketFavorite],
["SvgoMarketFuture", LazySvgoMarketFuture],
["SvgoMarketLightSelected", LazySvgoMarketLightSelected],
["SvgoMarketLightUnselected", LazySvgoMarketLightUnselected],
["SvgoMarketNoStar", LazySvgoMarketNoStar],
["SvgoMarketSearch", LazySvgoMarketSearch],
["SvgoMarketSpots", LazySvgoMarketSpots],
["SvgoMarketStar", LazySvgoMarketStar],
["SvgoMyIconsAccounts", LazySvgoMyIconsAccounts],
["SvgoMyIconsDeposit", LazySvgoMyIconsDeposit],
["SvgoMyIconsOrders", LazySvgoMyIconsOrders],
["SvgoMyIconsWithdraw", LazySvgoMyIconsWithdraw],
["SvgoMyWalletRecord", LazySvgoMyWalletRecord],
["SvgoReferralArrow", LazySvgoReferralArrow],
["SvgoReferralIcHow1", LazySvgoReferralIcHow1],
["SvgoReferralIcHow2", LazySvgoReferralIcHow2],
["SvgoReferralIcHow3", LazySvgoReferralIcHow3],
["SvgoReferralIcQrCode", LazySvgoReferralIcQrCode],
["SvgoReferralLogo", LazySvgoReferralLogo],
["SvgoSignUpArrow", LazySvgoSignUpArrow],
["SvgoSignUpCheck", LazySvgoSignUpCheck],
["SvgoSignUpClose", LazySvgoSignUpClose],
["SvgoSignUpCountryArrow", LazySvgoSignUpCountryArrow],
["SvgoSignUpEyeClose", LazySvgoSignUpEyeClose],
["SvgoSignUpEyeOpen", LazySvgoSignUpEyeOpen],
["SvgoSignUpPass", LazySvgoSignUpPass],
["SvgoSpotBg", LazySvgoSpotBg],
["SvgoSpotIcAdd", LazySvgoSpotIcAdd],
["SvgoSpotIcAttention", LazySvgoSpotIcAttention],
["SvgoSpotIcCalculatorS", LazySvgoSpotIcCalculatorS],
["SvgoSpotIcFire", LazySvgoSpotIcFire],
["SvgoSpotIcHistory", LazySvgoSpotIcHistory],
["SvgoSpotIcProfitSharing", LazySvgoSpotIcProfitSharing],
["SvgoSpotIcWebsite", LazySvgoSpotIcWebsite],
["SvgoSpotIcWhitePaper", LazySvgoSpotIcWhitePaper],
["SvgoSpotIcZoomout", LazySvgoSpotIcZoomout],
["SvgoSpotIconCamera", LazySvgoSpotIconCamera],
["SvgoSpotIconFullscreen", LazySvgoSpotIconFullscreen],
["SvgoSpotIconIcRight", LazySvgoSpotIconIcRight],
["SvgoSpotIconIndicators", LazySvgoSpotIconIndicators],
["SvgoSpotIconSetting", LazySvgoSpotIconSetting],
["SvgoUserAdvancedcertification", LazySvgoUserAdvancedcertification],
["SvgoUserAlert", LazySvgoUserAlert],
["SvgoUserApple", LazySvgoUserApple],
["SvgoUserBasiccertification", LazySvgoUserBasiccertification],
["SvgoUserCertificationstatus", LazySvgoUserCertificationstatus],
["SvgoUserCheck", LazySvgoUserCheck],
["SvgoUserCircle", LazySvgoUserCircle],
["SvgoUserClose", LazySvgoUserClose],
["SvgoUserDel", LazySvgoUserDel],
["SvgoUserDeposit", LazySvgoUserDeposit],
["SvgoUserDown", LazySvgoUserDown],
["SvgoUserEmail", LazySvgoUserEmail],
["SvgoUserFishing", LazySvgoUserFishing],
["SvgoUserGa", LazySvgoUserGa],
["SvgoUserGooglePlay", LazySvgoUserGooglePlay],
["SvgoUserHeadImg", LazySvgoUserHeadImg],
["SvgoUserIphone", LazySvgoUserIphone],
["SvgoUserKycCardFront", LazySvgoUserKycCardFront],
["SvgoUserKycCardThird", LazySvgoUserKycCardThird],
["SvgoUserKycInfo", LazySvgoUserKycInfo],
["SvgoUserKyc", LazySvgoUserKyc],
["SvgoUserLevel", LazySvgoUserLevel],
["SvgoUserMenu", LazySvgoUserMenu],
["SvgoUserPassword", LazySvgoUserPassword],
["SvgoUserSafety", LazySvgoUserSafety],
["SvgoUserSecretKey", LazySvgoUserSecretKey],
["SvgoUserSecurity", LazySvgoUserSecurity],
["SvgoUserTransfer", LazySvgoUserTransfer],
["SvgoUserUnverified", LazySvgoUserUnverified],
["SvgoUserVerifyState", LazySvgoUserVerifyState],
["SvgoUserVerify", LazySvgoUserVerify],
["SvgoUserWithdraw", LazySvgoUserWithdraw],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
